import Cashiers from './Cashiers.redux';

export default Cashiers;
